module.exports = __webpack_public_path__ + "static/media/gutgereift_landing3-min.b0b6a7f9.jpg";